module.exports = __webpack_public_path__ + "img/file_yellow.ae880744.svg";